import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { CompanyActions } from '../../redux/actions';

export const useFetchCompanySettings = () => {
  const dispatch = useAppDispatch();
  const companySettings = useAppSelector(state => state.Company.companySettings);

  useEffect(() => {
    if (!companySettings) {
      dispatch(CompanyActions.getCompanySettings.saga());
    }
  }, []);

  return companySettings;
};
